import React from 'react'
import './App.css';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import DeliveryReport from './pages/DeliveryReport';
import Billing from './pages/Billing';
import User from './pages/User';
import ApiDocumention from './pages/Api-Documention';
import WebHook from './pages/Web-Hook-Document';
import WebHookLogs from './pages/WebHook-Logs';
import SendMessage from './pages/SendMessage';
import DomainError from './pages/DomainError';
import { PrivateRoute } from './components';
import { Routes, Route, useNavigate } from "react-router-dom";
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import MessageLogs from './pages/MessageLogs';
import RoutingMethods from './pages/RoutingMethods';
import TemplateMessage from './pages/MessageTemplate';
import ConfigurePushNotification from './pages/configurePushNotification/ConfigurePushNotification';
import Configuresdk from './pages/ConfigureSDK/Configuresdk';
import ConfiguresdkLegacy from './pages/ConfigureSDK/ConfiguresdkLegacy';
import Integrations from './pages/Integrations/Integrations';
import MessageLogReport from './pages/MessageLogs/Report';
import ParserList from './pages/Parser/Parser';
import MessageAPIDoc from './pages/MessageAPI/MessageApi';
import ConfigureAPN from './pages/ConfigureApn/APN';
import Campaign from './pages/Campaign/Campaign.jsx';
import AddCampaign from './pages/Campaign/AddCampaign/AddCampaign.jsx';
import ContactsManagement from './pages/Contact/index.jsx';
import EditCampaign from './pages/Campaign/AddCampaign/EditCampaign.jsx';
import CampaignReport from './pages/Campaign/CampaignReport/Index.jsx';
import WebhookDocumentation from './pages/WebHookDocs/WebhookDocumentation.jsx';
import Cohort from './pages/Cohorts/Cohort.jsx';
import Boards from './pages/Boards/Boards.jsx';
import AddCohorts from './pages/Cohorts/AddCohorts.jsx';
import EditCohorts from './pages/Cohorts/EditCohort.jsx';
import CohortsDetails from './pages/Cohorts/CohortsDetails.jsx';
import Events from './pages/Events/Events.jsx';
import ExecutionReprt from './pages/Cohorts/CohortExecutionReport/ExecutionReprt.jsx';
import IncommingSMS from './pages/IncommingSMS/IncommingSMS.jsx';
import TemplateManager from './pages/TemplateManager/index.jsx';
import EventDocumentation from './pages/EventDocumentation/EventDocumentation.jsx';
import ContactApiDoc from './pages/ContactApiDoc/ContactApiDoc.jsx';
import SMSGrouping from './pages/Tools/SMSGrouping/SMSGroup.jsx';
import SafeMessageFilter from './pages/Tools/SafeMessage/SafeMessageFilter.jsx';
import Roles from './pages/RolesPermission.jsx/Roles.jsx';
import ContactReport from './pages/Contact/ContactReport.jsx';
import CampaignFlowBuilder from './pages/FlowBuilder/index.jsx';
import EditFlow from './pages/FlowBuilder/EditFlow.jsx';
import FlowList from './pages/FlowBuilder/FlowList.jsx';
import TemplateManagerNew from './pages/TemplateManager/CreateTemplate/TemplateManagerNew.jsx';
import SmartLinks from './pages/SmartLinks/SmartLinks.jsx';
import TemplateManagerNewCreate from './pages/TemplateManager/CreateTemplate/TemplateManagerNew.jsx';
import ChannelOptDoc from './pages/ChannelOptDocument/ChannelOptDoc.jsx';
import FlowExecution from './pages/FlowBuilder/FlowExecution/Flowexecution.jsx';
import ExecutionDetail from './pages/FlowBuilder/FlowExecutionDetails/ExecutionDetails.jsx';
import FunnelList from './pages/Funnels/FunnelsList.jsx';
import FunnelBuilder from './pages/Funnels/Builder/FunnelBuilder.jsx';
import EditFunnel from './pages/Funnels/Builder/EditFunnel.jsx';
import SessionJourneyExplorer from './pages/SessionJourney/SessionJourney.jsx';
import SessionAnalyzer from './pages/SessionAnalyzer/SessionAnalyzer.jsx';
import { Asklytics } from './pages/Asklytics/Asklytics.jsx';
import CSVMessageSender from './pages/Tools/CSVMessageSender/index.jsx';
import ConversionEvents from './pages/Tools/ConversionEvents/index.jsx';
import EmailDesignerTool from './pages/Tools/EmailDesigner/index.jsx';
import InAppDesigner from './pages/Tools/InAppDesigner/InAppDesigner.tsx';
import InAppMessageList from './pages/Tools/InAppDesigner/InAppMessageList.jsx';
import EmailTemplateList from './pages/Tools/EmailDesigner/EmailTemplateList.jsx';
import CSVCampaignReport from './pages/Tools/CSVMessageSender/Components/CSVReports.jsx';
import EditorPage from './pages/EditorPage';
import StoryPlayer from './pages/StoryPlayer';
import StoryViewPage from './pages/StoryViewPage';
import StoryDashboard from './pages/StoryDashboard';
import MyTickets from './pages/tickets/tickets/MyTickets.jsx';
import TicketDetail from './pages/tickets/tickets/TicketDetail.jsx';
import CreateTicket from './pages/tickets/tickets/CreateTicket.jsx';
import RFMModels from './pages/RFMModels/RFMModels.jsx';
import RFMConfiguration from './pages/RFMModels/RFMConfiguration.jsx';
import RFMDashboard from './pages/RFMModels/RFMDashboard.jsx';
import UsageReport from './pages/Reports/UsageReport.jsx';
import MetricTreeList from './pages/MetricTree/MetricTreeList.jsx';
import MetricTreeCanvas from './pages/MetricTree/MetricTreeCanvas.jsx';
import { PRIMARY_SCALE } from './theme/brand';

/*
 * NOTE: brand values are deliberately NOT re-exported from here.
 *
 * App.js imports every page, so anything importing back from App.js creates an
 * import cycle — webpack then resolves the named export to undefined ("possible
 * exports: default"). Import from 'src/theme/brand' directly instead. In JSX and
 * CSS prefer `var(--brand-primary)`; reach for the JS values only where CSS
 * variables cannot reach (Highcharts, react-pdf, exported email HTML).
 */


function App() {
  const navigate = useNavigate();
  const Button = {

    variants: {
      ghost: {
        bg: "transparent",
        color: "gray.700",
        _hover: {
          bg: "#e2e8f0 !important",
          color: "black !important"
        },
        _active: {
          bg: "gray.200",
        },
        _focus: {
          boxShadow: "none",
        },
      },
    },
  };

  const theme = extendTheme({
    colors: {
      // Both names resolve to the env-driven brand ramp from src/theme/brand.js,
      // so `colorScheme="brand"` / `bg="primary.500"` follow REACT_APP_PRIMARY_COLOR.
      // (This replaced a stale hardcoded green palette that nothing consumed.)
      brand: PRIMARY_SCALE,
      primary: PRIMARY_SCALE,
      // Chakra's built-in `blue` is remapped onto the brand ramp on purpose.
      // ~129 call sites use colorScheme="blue" for primary Buttons, Tabs, Tags and
      // Badges, and Chakra also defaults every Input/Select/Textarea focus ring to
      // blue.500. Without this they would all stay blue under a non-blue brand.
      // Semantic colours (green/red/orange, and the per-channel colours such as
      // SMS #155dfc) are deliberately left alone.
      blue: PRIMARY_SCALE,
    },
    components: {
      Button,
    },
    // fontWeights: {
    //   normal: 300,
    //   medium: 400,
    //   semibold: 500,
    //   bold: 600,
    //   extrabold: 700,
    // },
    // // styles: {
    // //   global: {
    // //     '.chakra-text': {
    // //       fontWeight: '500', // semi-bold by default
    // //     },
    // //   },
    // // },

  });



  return (

    <ChakraProvider theme={theme}>

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/incomming-sms" element={
          <PrivateRoute>
            <IncommingSMS header={"Incoming SMS Messages"} />

          </PrivateRoute>
        } />

        <Route path="/dashboard" element={
          <PrivateRoute>
            <Dashboard header={"Dashboard"} />
          </PrivateRoute>
        } />

        <Route path="/delivery-report" element={
          <PrivateRoute>
            <DeliveryReport header={"Delivery Report"} />
          </PrivateRoute>
        } />

        <Route path="/billing" element={
          <PrivateRoute>
            <Billing />
          </PrivateRoute>
        } />

        <Route path="/integrations" element={
          <PrivateRoute>
            <Integrations />
          </PrivateRoute>
        } />

        <Route path="/user-management/user" element={
          <PrivateRoute>
            <User header={"Manage Users"} />
          </PrivateRoute>
        } />
        <Route path="/user-management/roles-permission" element={
          <PrivateRoute>
            <Roles header={"Manage Users"} />
          </PrivateRoute>
        } />
        <Route path="/webhook" element={
          <PrivateRoute>
            <WebHookLogs header={"WebHook Logs"} />
          </PrivateRoute>
        } />
        <Route path="/parser" element={
          <PrivateRoute>
            <ParserList header={"Message Parser"} />
          </PrivateRoute>
        } />

        <Route path="/documentation/api-doc" element={
          <PrivateRoute>
            <ApiDocumention header={"Variable API Documentation"} />
          </PrivateRoute>
        } />
        <Route path="/documentation/evt-docs" element={
          <PrivateRoute>
            <EventDocumentation header={"Variable API Documentation"} />
          </PrivateRoute>
        } />
        <Route path="/documentation/contact-api" element={
          <PrivateRoute>
            <ContactApiDoc header={"Contact API Documentation"} />
          </PrivateRoute>
        } />

        <Route path="/web-hook" element={
          <PrivateRoute>
            <WebHook />
          </PrivateRoute>
        } />

        <Route path="/send-message" element={
          <PrivateRoute>
            <SendMessage header={"Send Test Message"} />

          </PrivateRoute>
        } />
        <Route path="/report" element={
          <PrivateRoute>
            <MessageLogReport />

          </PrivateRoute>
        } />
        <Route path="/reports/usage-report" element={
          <PrivateRoute>
            <UsageReport header="Usage Report" />
          </PrivateRoute>
        } />
        <Route path="/marketing/campaign" element={
          <PrivateRoute>
            <Campaign header={"Campaign Manager"} />

          </PrivateRoute>
        } />
        <Route path="/campaign/add" element={
          <PrivateRoute>
            <AddCampaign header={"Campaign Manager"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/cohorts" element={
          <PrivateRoute>
            <Cohort header={"Cohort Analysis"} />

          </PrivateRoute>
        } />
        {/* FEAT-BOARDS-0001 — Mixpanel-style narrative dashboards */}
        <Route path="/insights" element={<PrivateRoute><Boards /></PrivateRoute>} />
        <Route path="/insights/:id" element={<PrivateRoute><Boards /></PrivateRoute>} />
        <Route path="/cohort-report/:id" element={
          <PrivateRoute>
            <ExecutionReprt header={"Execution Report"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/event" element={
          <PrivateRoute>
            <Events header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/sms-group" element={
          <PrivateRoute>
            <SMSGrouping header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/safe-message-filter" element={
          <PrivateRoute>
            <SafeMessageFilter header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/csv-message-sender" element={
          <PrivateRoute>
            <CSVMessageSender header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/conversion-events" element={
          <PrivateRoute>
            <ConversionEvents />
          </PrivateRoute>
        } />
        <Route path="/tools/csv-message-sender-report/:id" element={
          <PrivateRoute>
            <CSVCampaignReport header={"Event Management"} />

          </PrivateRoute>
        } />
        <Route path="/tools/email-templates" element={
          <PrivateRoute>
            <EmailTemplateList />
          </PrivateRoute>
        } />
        <Route path="/tools/email-designer" element={
          <PrivateRoute>
            <EmailDesignerTool />
          </PrivateRoute>
        } />
        <Route path="/tools/email-designer/:id" element={
          <PrivateRoute>
            <EmailDesignerTool />
          </PrivateRoute>
        } />
        <Route path="/tools/in-app-messages" element={
          <PrivateRoute>
            <InAppMessageList />
          </PrivateRoute>
        } />
        <Route path="/tools/in-app-designer" element={
          <PrivateRoute>
            <InAppDesigner onBack={() => navigate('/tools/in-app-messages')} />
          </PrivateRoute>
        } />
        <Route path="/tools/in-app-designer/:id" element={
          <PrivateRoute>
            <InAppDesigner onBack={() => navigate('/tools/in-app-messages')} />
          </PrivateRoute>
        } />
        <Route path="/cohorts/create" element={
          <PrivateRoute>
            <AddCohorts header={"Add New Cohort"} />

          </PrivateRoute>
        } />
        <Route path="/cohorts/detail/:id" element={
          <PrivateRoute>
            <CohortsDetails header={"Cohort Details"} />

          </PrivateRoute>
        } />
        <Route path="/cohort/edit/:id" element={
          <PrivateRoute>
            <EditCohorts header={"Edit Cohort"} />

          </PrivateRoute>
        } />
        <Route path="/campaign/:id" element={
          <PrivateRoute>
            <EditCampaign header={"Campaign Manager"} />

          </PrivateRoute>
        } />
        <Route path="/campaign/reports/:id" element={
          <PrivateRoute>
            <CampaignReport header={"Campaign Manager"} />

          </PrivateRoute>
        } />
        <Route path="/message-api-doc" element={
          <PrivateRoute>
            <MessageAPIDoc header={"Message API Documentation"} />

          </PrivateRoute>
        } />
        <Route path="/documentation/webhook-doc" element={
          <PrivateRoute>
            <WebhookDocumentation header={"WebHook Documentation"} />

          </PrivateRoute>
        } />
        {/* <Route path="/webhook-doc" element={
          <PrivateRoute>
            <WebhookDocumentation header={"WebHook Documentation"} />

          </PrivateRoute>
        } /> */}
        <Route path="/documentation/configure-apn" element={
          <PrivateRoute>
            < ConfigureAPN header={"Apple Push Notification Configuration"} />

          </PrivateRoute>
        } />
        <Route path="/contacts" element={
          <PrivateRoute>
            < ContactsManagement header={"Contacts"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/flow-create" element={
          <PrivateRoute>
            < CampaignFlowBuilder header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/flow" element={
          <PrivateRoute>
            <FlowList header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/flow/:id" element={
          <PrivateRoute>
            < EditFlow header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/session-journey" element={
          <PrivateRoute>
            < SessionJourneyExplorer header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        {/* FEAT-SESSIONS-001 — Session Analyzer (rules on ended sessions → xFlow) */}
        <Route path="/marketing/session-analyzer" element={
          <PrivateRoute>
            <SessionAnalyzer header={"Session Analyzer"} />
          </PrivateRoute>
        } />
        <Route path="/marketing/flow-execution/:id" element={
          <PrivateRoute>
            < FlowExecution header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/Asklytics" element={
          <PrivateRoute>
            < Asklytics />

          </PrivateRoute>
        } />
        <Route path="/marketing/flow-execution-detail/:id" element={
          <PrivateRoute>
            < ExecutionDetail header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/funnels" element={
          <PrivateRoute>
            < FunnelList header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/funnels-create" element={
          <PrivateRoute>
            < FunnelBuilder header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/funnels-edit/:id" element={
          <PrivateRoute>
            <EditFunnel header={"Campaign Flow Builder"} />

          </PrivateRoute>
        } />
        <Route path="/marketing/funnels-view/:id" element={
          <PrivateRoute>
            < FunnelBuilder header={"Campaign Flow Builder"} readOnly={true} />

          </PrivateRoute>
        } />
        <Route path="/contacts-report/:id" element={
          <PrivateRoute>
            < ContactReport header={"Contacts"} />

          </PrivateRoute>
        } />
        <Route path="/documentation/configure-push-notification" element={
          <PrivateRoute>
            <ConfigurePushNotification header={"Configure Push Notification"} />

          </PrivateRoute>
        } />
        <Route path="/documentation/channel-opt" element={
          <PrivateRoute>
            <ChannelOptDoc header={"Configure Push Notification"} />

          </PrivateRoute>
        } />
        <Route path="/documentation/configure-sdk" element={
          <PrivateRoute>
            <ConfiguresdkLegacy header={"Configure SDK"} />

          </PrivateRoute>
        } />
        <Route path="/documentation/configure-sdk-new" element={
          <PrivateRoute>
            <Configuresdk header={"Configure SDK"} />

          </PrivateRoute>
        } />
        <Route path="/message-logs" element={
          <PrivateRoute>
            <MessageLogs header={"Delivery Report"} />

          </PrivateRoute>
        } />
        <Route path="/routing-methods" element={
          <PrivateRoute>
            <RoutingMethods header={"Routing Methods"} />

          </PrivateRoute>
        } />
        <Route path="/template-message" element={
          <PrivateRoute>
            <TemplateMessage header={"Message Templates"} />

          </PrivateRoute>
        } />
        <Route path="/domain-error" element={
          <DomainError />
        } />

        <Route path="/template-manager" element={
          <PrivateRoute>
            <TemplateManager />

          </PrivateRoute>
        } />
        <Route path="/template-add" element={
          <PrivateRoute>
            {/* <CreateTemplate /> */}
            <TemplateManagerNew />

          </PrivateRoute>
        } />
        <Route path="/template-add-new" element={
          <PrivateRoute>
            {/* <CreateTemplate /> */}
            <TemplateManagerNew />

          </PrivateRoute>
        } />
        <Route path="/template-edit/:id" element={
          <PrivateRoute>
            {/* <EditTemplate />
             */}
            <TemplateManagerNewCreate isEdit={true} />


          </PrivateRoute>
        } />
        <Route path="/template-edit-new/:id" element={
          <PrivateRoute>
            <TemplateManagerNewCreate isEdit={true} />

          </PrivateRoute>
        } />
        <Route path="/support/tickets" element={
          <PrivateRoute>
            <MyTickets />
          </PrivateRoute>
        } />
        <Route path="/support/ticket/:id" element={
          <PrivateRoute>
            <TicketDetail />
          </PrivateRoute>
        } />
        <Route path="/support/create-ticket" element={
          <PrivateRoute>
            <CreateTicket />
          </PrivateRoute>
        } />


        <Route path="/marketing/rfm-models" element={
          <PrivateRoute>
            <RFMModels header={"RFM Models"} />
          </PrivateRoute>
        } />
        <Route path="/marketing/rfm-models/configure/:id" element={
          <PrivateRoute>
            <RFMConfiguration header={"Configure RFM Model"} />
          </PrivateRoute>
        } />
        <Route path="/marketing/rfm-models/dashboard/:id" element={
          <PrivateRoute>
            <RFMDashboard header={"RFM Analytics Dashboard"} />
          </PrivateRoute>
        } />

        {/* ── Metric Tree (standalone feature) ── */}
        <Route path="/metric-tree" element={<PrivateRoute><MetricTreeList /></PrivateRoute>} />
        <Route path="/metric-tree/:id" element={<PrivateRoute><MetricTreeCanvas /></PrivateRoute>} />

        {/* ── Smart Links (M06 cycle 1) ── */}
        <Route path="/marketing/smart-links/*" element={<PrivateRoute><SmartLinks /></PrivateRoute>} />


        {/* ── Story Builder ── */}
        <Route path="/marketing/story-builder" element={<PrivateRoute><StoryDashboard /></PrivateRoute>} />
        <Route path="/marketing/story-builder/:id/edit" element={<EditorPage />} />
        <Route path="/marketing/story-builder/:id/play" element={<StoryPlayer />} />
        <Route path="/marketing/story-builder/:id/view" element={<StoryViewPage />} />
      </Routes>

    </ChakraProvider>

  );
}

export default App;
